"use client";

import Translations from "@translate/components/Portfolio/PortfolioAskEdAction/PortfolioAskEdAction";
import React from "react";
import { cn } from "utils";
import { I18nUtil } from "@utils/i18n";

const I18n = I18nUtil.createScoped(Translations);

export interface PortfolioAskEdActionProps {
  className?: string;
  onClick?: () => void;
}

/**
 * Portfolio 顶部 Ask Ed CTA（Figma `102007:387039` / Value Row Annotation）。
 * 点击 → Chat（由调用方注入 onClick，通常接 useResponsiveChatOpen）。
 */
export const PortfolioAskEdAction: React.FC<PortfolioAskEdActionProps> = ({
  className,
  onClick,
}) => {
  return (
    <button
      type="button"
      className={cn(
        "inline-flex h-9 shrink-0 items-center justify-center gap-0.5 overflow-hidden rounded-2 px-3 py-2",
        "bg-background_brand_overlay100 text-content_inverse_primary body_medium_m",
        "hover:brightness-95 active:brightness-90",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-background_brand_overlay100/60",
        className,
      )}
      onClick={onClick}
      data-openreplay-label="Portfolio · Ask Ed"
      data-tracking-eventname="ask_ed_tap"
      aria-label={I18n.t("Ask Ed")}
    >
      {I18n.t("Ask Ed")}
    </button>
  );
};
